import { useMutation } from '@tanstack/react-query';

import cruiseIqService, { type CruiseIqQueryRequest } from '~/services/cruises/CruiseIqService';

export function useExecuteCruiseIqQuery() {
  return useMutation({
    mutationFn: (params: CruiseIqQueryRequest) => cruiseIqService.executeQuery(params),
  });
}
